import { Modal, Grid, Button, Box, Typography } from '@mui/material';
import { useState } from 'react';
import imgSrc from '../ppTaxStatementSample2022.png';
import { colors } from 'src/styles/theme';
const TroubleLoggingInModal = ({ btnTxt = '' }) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const modalBoxStyle = {
    position: 'absolute',
    top: { md: '50%', xs: '50%' },
    left: { md: '50%', xs: '50%' },
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: `2px solid ${colors.primary.dark}`,
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <a onClick={handleOpen} data-cy="toubleLoggingModal">
        {btnTxt}
      </a>
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalBoxStyle}>
          <Grid container columns={1} spacing={2}>
            <Grid item>
              <Box
                component="img"
                sx={{
                  maxWidth: '80vw',
                  maxHeight: '100vh',
                }}
                alt="trouble logging in image"
                id="troubleLoggingImage"
                src={imgSrc}
              />
            </Grid>
            <Grid item>
              <Typography>
                For more information or to access Personal Property Forms, please visit{' '}
                <a href="https://www.utahcounty.gov/Dept/Assess/PersonalProperty.asp">
                  our FAQ page.
                </a>
              </Typography>
            </Grid>
            <Grid container item sx={{ justifyContent: 'flex-end' }}>
              <Grid item>
                <Button data-cy="close" variant="contained" onClick={handleClose}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default TroubleLoggingInModal;
